export const InventoryTypeArray = [
    { value: 1, text: 'Плановая' },
    { value: 2, text: 'Внеплановая' },
    { value: 3, text: 'Выборочная' },
    { value: 4, text: 'Полная' }]

export const DocumentStatusArray = [
    { value: 1, text: 'Черновик' },
    { value: 2, text: 'В работе' },
    { value: 3, text: 'На сверке' },
    { value: 4, text: 'Завершена' },
    { value: 5, text: 'Отменена' }
]

export const InventoryResultArray = [
    { value: 1, text: 'Расхождений нет' },
    { value: 2, text: 'Есть расхождения' }
]

export const DiscrepancyReasonArray = [
    { value: 0, text: '' },
    { value: 1, text: 'Не установлена' },
    { value: 2, text: 'Порча' },
    { value: 3, text: 'Кража' },
    { value: 4, text: 'Ошибка при приёмке' },
    { value: 5, text: 'Ошибка при отпуске' },
    { value: 6, text: 'Другое' }
]
